"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("../column-config/ColumnConfig"));
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
/**
 * @deprecated Image is not WCAG compliant. @see {@link IconColumnConfig}
 */
class IconsColumnConfig extends ColumnConfig_1.default {
    constructor(title, headerClassName, mapDataToField, sortable, clickable) {
        super(title, headerClassName, mapDataToField, sortable, clickable);
        this.renderer = {
            render(ctx, obj) {
                const label = new fmko_ts_widgets_1.Label();
                for (const image of obj.images) {
                    label.add(image);
                }
                ctx.setWidget(label);
            },
            canRender(o) {
                return true;
            }
        };
    }
    getData(data) {
        return { data: data, images: this.mapDataToTD(data) };
    }
}
exports.default = IconsColumnConfig;
//# sourceMappingURL=IconsColumnConfig.js.map